export var DisplayDataType;
(function (DisplayDataType) {
    DisplayDataType[DisplayDataType["DecimalSystem"] = 0] = "DecimalSystem";
    DisplayDataType[DisplayDataType["HexadecimalSystem"] = 1] = "HexadecimalSystem";
    DisplayDataType[DisplayDataType["Binary"] = 2] = "Binary";
})(DisplayDataType || (DisplayDataType = {}));
